























































































import { Component, Vue } from "vue-property-decorator";
import QuickSnack from "@/components/QuickSnack.vue";
import OpenApiDocs from "@/components/OpenApiDocs.vue";
import { domain } from "@/domain";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";

@Component({
  components: { QuickSnack, OpenApiDocs }
})
export default class PaymentLinkAPI extends Vue {
  apiLoadError = false;
  apiLoading = true;
  apiEnabledLoading = false;
  apiKeyLoading = false;
  userConfig = {
    publicApiEnabled: false,
    publicApiKey: ""
  };

  get lang() {
    return this.$store.state.lang.data;
  }

  get snack(): QuickSnack {
    return this.$refs.snack as QuickSnack;
  }

  get fullApiKey() {
    if (!this.userConfig.publicApiKey) {
      return "";
    }
    return "PAYTEF-TOKEN " + this.userConfig.publicApiKey;
  }

  get isIE11() {
    return uiUtil.isIE11();
  }

  created() {
    util.promiseEnd(this.refreshConfig());
  }

  async refreshConfig() {
    this.apiLoading = true;
    this.apiLoadError = false;
    try {
      const config = await domain.backend.getUserConfig();
      this.userConfig = config;
    } catch (err) {
      util.logError("Error loading config", err);
      this.snack.show(this.lang.errorLoadingConfig, "error");
    }
    this.apiLoading = false;
  }

  async enableClick() {
    this.apiEnabledLoading = true;
    try {
      const config = await domain.backend.setUserConfig({
        publicApiEnabled: this.userConfig.publicApiEnabled
      });
      this.userConfig = config;
    } catch (err) {
      util.logError("Error loading config", err);
      this.snack.show(this.lang.errorSavingConfig, "error");
      util.promiseEnd(this.refreshConfig());
    }
    this.apiEnabledLoading = false;
  }

  async makeNewKey() {
    if (confirm(this.lang.generateNewTokenConfirmation)) {
      this.apiEnabledLoading = true;
      try {
        const config = await domain.backend.setUserConfig({
          publicApiEnabled: this.userConfig.publicApiEnabled,
          action: "newkey"
        });
        this.userConfig = config;
      } catch (err) {
        util.logError("Error loading config", err);
        this.snack.show(this.lang.errorSavingConfig, "error");
      }
      this.apiEnabledLoading = false;
    }
  }

  cmdCopyURL() {
    const input = (this.$refs.publicApiKey as Vue).$refs.input as HTMLInputElement;
    if (util.copyToClipboard(this.fullApiKey, input)) {
      this.snack.show(this.lang.linkCopied, "success");
    }
    this.cmdSelectAll();
  }

  cmdSelectAll() {
    const input = (this.$refs.publicApiKey as Vue).$refs.input as HTMLInputElement;
    if (input) {
      input.focus();
      this.$nextTick(() => {
        input.select();
        this.snack.show(this.lang.pressControlC, "");
      });
    }
  }
}
